import React, { useEffect, useState } from 'react'
import swal from 'sweetalert'
import CurrencyFormat from "react-currency-format"
import styles from './edosCuenta.module.sass'

import { useIsMobile } from 'hooks/useIsMobile'

import { downloadStatement } from 'services/DownloadStatement'
import { getFacturacionMeses } from 'services/FacturacionMeses'

import { dataLayerButtons } from 'functions/dataLayerFunction'
import { decodeStorage } from 'functions/storageBase64'
import { dateFormatClaro, dateFormatDDMM, dateFormatDownload } from 'functions/dateFormat'

import { PagarPlan } from 'components/Credito/ButtonPayCard';
import { MovementsCards } from 'pages/Credito/6-Movimientos/ModulosMovimientos'


export function useEdosCuenta(){

    const { isMobile } = useIsMobile()

    const [ cardending, setCardending ] = useState(decodeStorage('cardending'))
    const [ periodDownload, setPeriodDownload ] = useState()
    const [ respDownload, setRespDownload ] = useState()
    const [ respMeses, setRespMeses ] = useState()
    const [ loading, setLoading ] = useState(false)
    const [ sendML, setSendML ] = useState(false)
    const [ errorCode, setErrorCode ] = useState()
    const [ acountStatusData, setAcountStatusData ] = useState(false)
    const [ sinEstados, setSinEstados ] = useState(false)
    const [ date, setDate ] = useState()
    const [ showPayment, setShowPayment ] = useState(false)

    const minimo = decodeStorage('lastConsultData')[0]?.monto_pendiente_pago
    const oldDate = decodeStorage('lastConsultData')[0]?.fecha_pago
    const fechaLimite = decodeStorage('lastConsultData')[0]?.payday_limit
    const pagoMinimo = decodeStorage('lastConsultData')[0]?.minimum_to_pay
    const balanceAlCorte = decodeStorage('lastConsultData')[0]?.new_balance_cutting

    const nextDate = (fecha) => {
        let fechaBase = String(fecha)

        let rangoDias = 5

        let anio = fechaBase.substring(1, 3)
        let mes = fechaBase.substring(3, 5)
        let dia = fechaBase.substring(5, 7)
        let fechaString = String(`${mes} ${dia} ${anio}`)
        let FechaFormateada = new Date(fechaString)

        let fechaPre = FechaFormateada.setDate(FechaFormateada.getDate() + rangoDias)
        let fechaNueva = new Date(fechaPre)

        let diaNueva = fechaNueva.getDate()
        let mesNueva = fechaNueva.getMonth() + 1
        let anioNueva = String(fechaNueva.getFullYear()).substring(2, 4)

        let fechaReturn = String(`1${anioNueva}${mesNueva}${diaNueva}`)

        return fechaReturn
    }

    useEffect(()=>{
        setDate(nextDate(oldDate))
        if(pagoMinimo > 0 && balanceAlCorte > 0){
            setShowPayment(true)
        }
    },[])

    //Download Statement
    useEffect(()=>{
        if(cardending){
            if(periodDownload){
                setLoading(true)
                downloadStatement({cardending, period : periodDownload})
                .then(setRespDownload)
            }
        }else{
            setCardending(decodeStorage('cardending'))
        }
    },[periodDownload, cardending])
    useEffect(()=>{
        if(respDownload?.statusCode === 200){
            setLoading(false);
            if(respDownload?.data?.returnCode !== "00"){
                setSinEstados(true)
            }
            else if(respDownload?.data?.returnText === "No se encontraron resultados"){
                setSinEstados(true);
            }
            else{
                if(respDownload?.data?.contenido){
                    const linkSource = `data:application/pdf;base64,${respDownload?.data.contenido}`;
                    const downloadLink = document.createElement("a");
                    const fileName = `${respDownload?.data?.nombreDocumento}.pdf`;
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                    dataLayerButtons({eventName: "descargar_estadocuenta"});
                    setSinEstados(false);
                }
                swal({
                    type: 'info',
                    text: "Se descargó tu estado de cuenta.",
                    timer: "3000",
                    showConfirm: false
                })
            }
        }
        else if(respDownload?.statusCode === 400){
            let codeError = JSON.parse(respDownload?.data);
            setLoading(false);
            setErrorCode(codeError);
        }else if(respDownload?.statusCode >= 500){
            setLoading(false);
            setErrorCode(respDownload?.statusCode);
        }
    },[respDownload])


    //List Months
    useEffect(()=>{
        getFacturacionMeses()
        .then(setRespMeses)
    },[])
    useEffect(()=>{
        if(respMeses?.statusCode === 200){
            setSendML(false)
            setLoading(false)
            let arrObj= Object.values(respMeses?.data)
            let arrMEses = []
            //array de fechas
            if(arrObj){
                arrObj.forEach((item, index) => {
                    if(item.includes("-")){
                        arrMEses.push(
                            {
                                id: index-2, 
                                fecha: `${item.split("-")[1]}/${item.split("-")[0]}`, 
                                rango: `${item.split("-")[1]}/${item.split("-")[0]}`
                            }
                        )
                    } 
                });
            }
            //se asignan a objeto
            setAcountStatusData({fechas: arrMEses})
            // setAcountStatusData({fechas: []})
        }
        else if(respMeses?.statusCode === 400){
            let codeError = JSON.parse(respMeses?.data)
            setLoading(false)
            setErrorCode(codeError);
        }else if(respMeses?.statusCode >= 500){
            setLoading(false)
            setErrorCode(respMeses?.statusCode)
        }
    },[respMeses])

    let montoMinimo = minimo && <CurrencyFormat
        value={Number(minimo % 1) === 0 ? minimo + '.001' : minimo}
        displayType={'text'}
        decimalScale={2}
        FixedDecimalScale={true}
        thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>} />;

    const sendMonthList = () => {
        setSendML(true)
        setLoading(true)
    }
    const sendDownloadStatement = (periodo) => {
        setPeriodDownload(periodo)
        setLoading(true)
    }

    const dataTransaction = {
        showPayment: showPayment,
        cardending: cardending,
        fechaPago: fechaLimite,
        fechaCorte: oldDate,
        montoMinimo: montoMinimo
    }

    return {
        sendMonthList,
        sendDownloadStatement,
        errorCode,
        acountStatusData,
        dataTransaction,
        date,
        loading,
        isMobile
    }
}

export function ListMonths(props){
    const {
        meses,
        setRango,
        setIndex
    } = props

    const handleRango = (e, index) => {
        let anio = e.split("/")[1]
        let mes = e.split("/")[0]
        let period = {
            anio: anio,
            mes: mes
        }
        // console.log(e, index)
        // console.log(period)
        setIndex(index)
        setRango(period)
    }

    return(
        meses?.length > 0
            ?
                <ul className={styles?.listMonths}>
                    {
                        meses?.map((item, index) => {
                            return(
                                <li key={index} onClick={(e) => handleRango(item?.rango, index)}>
                                    {dateFormatDownload(item?.fecha)}
                                </li>
                            )
                        })
                    }
                </ul>
            : null
    )
}

export function EmptyMonths(props){
    // const {
    //     date
    // } = props

    const date = decodeStorage('fecharealfacturacion')

    return(
        <div className={styles?.noMonths}>
            <img src="/credito-claroshop/img/newCredito/sin_edoCuenta.svg" className={styles?.noMonthsImage} />
            <h2 className={styles?.h1} >Aún no tienes estado de cuenta</h2>
            {date != 0
                ? <p className={styles?.h2}>Se generará hasta tu fecha de facturación: <strong>{dateFormatClaro(date)}</strong></p>
                : null
            }
        </div>
    )
}

export function ResultPerMonth(props){
    const {
        perMonth,
        respMovements,
        dataTransaction,
        setRango,
        index
    } = props

    const [titleMessage, ] = useState('Fecha limite de pago: ')
    const [subTitleMessage, ] = useState('Fecha de corte: ')
    const [movementsPerMonth, setMovementPerMonth] = useState(respMovements)

    useEffect(()=>{
        if(perMonth){
            let respMov = respMovements?.filter(item => String(item?.date_activity).substring(1,5) === `${String(perMonth?.anio).substring(2,4)}${perMonth?.mes}`)
            setMovementPerMonth(respMov)
        }
    },[perMonth])

    const handleRango = () => {
        setRango(perMonth)
    }

    return(
        <div className={styles?.resultPerMonth}>
            <h2 className={styles?.h1} >{dateFormatDownload(`${perMonth?.mes}/${perMonth?.anio}`)}</h2>

            <div className={styles?.cardDownloadMonths}>
                {dataTransaction?.showPayment && index === 0
                    ?
                        <div className={styles?.actionToPay}>
                            <div className={styles?.montlyPayment}>{dataTransaction?.montoMinimo}</div>
                            <div className={styles?.payDeadLine}>{titleMessage} <span>{dateFormatDDMM(dataTransaction?.fechaCorte)}</span></div>
                            <div className={styles?.payDeadLine2}>{subTitleMessage} <span>{dateFormatDDMM(dataTransaction?.fechaPago)}</span></div>
                            <div className={styles?.contBtnsPago}>
                                <PagarPlan cardending={dataTransaction?.cardending} nameButton="Pagar" />
                            </div>
                        </div>
                    : null
                }
                <div onClick={handleRango} className={styles?.btnDownloadMonth}>Descargar estado de cuenta en PDF</div>
            </div>

            {respMovements
                ?
                    <MovementsCards
                        respMovements={movementsPerMonth} 
                    />
                : null

            }

        </div>
    )
}